<template>
<div class="chapter">
<div class="inner_page">
<div id="Title_Page.html" xml:lang="en-US">
<div class="Basic-Text-Frame-2">
<p class="para-style-override-1" id="toc_marker-3">
<img alt="softp.eps" src="images/softp_fmt.png" width="85%"/>
</p>
<p class="pubs"><span>Llewellyn Publications</span></p>
<p class="pubs"><span>Woodbury, Minnesota</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title_Page.vue?3b2ac248